<template>
    <div>
        <v-app>
            <md-field>
                <label>类型</label>
                <md-select v-model="meta.type" name="trigger" id="trigger">
                    <md-option value="device">设备</md-option>
                    <md-option value="scene">场景</md-option>
                </md-select>
            </md-field>
            <md-field v-if="meta.type == 'scene'">
                <Tree :setting="setting" :nodes="treeData" ref="tree" class="md-tree" />
            </md-field>
            <md-field>
                <label>触发方式</label>
                <md-select v-model="trigger" name="trigger" id="trigger">
                    <md-option value="Auto">自动</md-option>
                    <md-option value="Click">点击目标</md-option>
                    <md-option value="Pattern">属性改变</md-option>
                    <md-option value="UIButton">UI点击</md-option>
                    <md-option value="HandTrigger">手动触发</md-option>
                    <!-- <md-option value="devInstall">设备安装触发</md-option> -->
                    <md-option value="ExamTrigger">考点触发</md-option>
                </md-select>
            </md-field>
            <md-field v-if="trigger === 'Pattern'">
                <label>属性列表</label>
                <md-select v-model="meta.prop" name="prop" id="prop">
                    <md-option value="string">字符串</md-option>
                    <md-option value="bool">布尔值</md-option>
                </md-select>
            </md-field>
            <md-field v-if="trigger === 'Pattern'">
                <label>属性值</label>
                <md-input v-model="meta.propValue" type="text"> </md-input>
                <span class="md-helper-text">请输入要改变到的属性值</span>
            </md-field>
            <md-field v-if="trigger === 'UIButton'">
                <label>按钮</label>
                <md-select v-model="meta.btn" name="btn" id="btn">
                    <md-option value="formSubmit">表单提交</md-option>
                    <md-option value="btnOk">确认</md-option>
                    <md-option value="btnCancel">取消</md-option>
                    <md-option value="devLib">点击设备库</md-option>
                    <md-option value="miniMap">点击小地图</md-option>
                    <md-option value="openUi">打开UI</md-option>
                    <md-option value="closeUi">关闭UI</md-option>
                </md-select>
            </md-field>
            <md-field v-if="trigger === 'UIButton'">
                <div>
                    <v-btn color="success" small @click.stop="showAttachForm">添加</v-btn>
                    <v-data-table no-data-text="暂无附加信息" :headers="headers" :items="meta.appendInfo ? meta.appendInfo : []" hide-default-footer
                        class="paginated-table table-striped table-hover">
                        <template v-slot:item.option="{ item }">
                            <v-btn icon color="error" @click.native="handleDelete(item)" small>
                                <v-icon small>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </div>
                <v-dialog v-model="showAttachDialog" hide-overlay max-width="600px">
                    <v-card>
                        <v-card-title class="md-card-header-icon md-card-header-green">
                            <div class="card-icon">
                                <md-icon>public</md-icon>
                            </div>
                            <h4 class="title">附加信息</h4>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="appendForm.appendInfo" label="附加信息" hint="请输入附加信息"></v-text-field>
                        </v-card-text>
                        <v-dialog-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="handleAttachConfirm">确 定</v-btn>
                            <v-btn color="success" @click="showAttachDialog = false">关 闭</v-btn>
                        </v-dialog-actions>
                    </v-card>
                </v-dialog>
            </md-field>
            <md-field v-if="trigger === 'devInstall'">
                <label>载体</label>
                <md-input v-model="meta.supportInstallMetaName" type="text"> </md-input>
                <span class="md-helper-text">请输载体设备名称</span>
            </md-field>
            <md-field v-if="trigger === 'devInstall'">
                <label>设备</label>
                <md-input v-model="meta.installMetaName" type="text"> </md-input>
                <span class="md-helper-text">请输入要安装的设备名称</span>
            </md-field>
            <md-field v-if="trigger === 'devInstall'">
                <div class="md-layout">
                    <div class="md-layout-item md-size-20 md-small-size-100">
                        <label style="padding-top: 5px">是否销毁</label>
                    </div>
                    <div class="md-layout-item md-size-80 md-small-size-100">
                        <md-switch v-model="meta.isDestroy"></md-switch>
                    </div>
                </div>
            </md-field>
            <md-field v-if="trigger === 'devInstall'">
                <label>延迟销毁时间</label>
                <md-input v-model="meta.delay" type="text"> </md-input>
                <span class="md-helper-text">请输入延迟销毁时间</span>
            </md-field>
            <md-field v-if="trigger === 'ExamTrigger'">
                <label>考题</label>
                <md-input v-model="meta.ExamTrigger" type="text"> </md-input>
                <span class="md-helper-text">考题</span>
            </md-field>
            <md-field v-if="trigger === 'ExamTrigger'">
                <label>选项A</label>
                <md-input v-model="meta.choiceA" type="text"> </md-input>
                <span class="md-helper-text">请输入选项A</span>
            </md-field>
            <md-field v-if="trigger === 'ExamTrigger'">
                <label>选项B</label>
                <md-input v-model="meta.choiceB" type="text"> </md-input>
                <span class="md-helper-text">请输入选项B</span>
            </md-field>
            <md-field v-if="trigger === 'ExamTrigger'">
                <label>选项C</label>
                <md-input v-model="meta.choiceC" type="text"> </md-input>
                <span class="md-helper-text">请输入选项C</span>
            </md-field>
            <md-field v-if="trigger === 'ExamTrigger'">
                <label>选项B</label>
                <md-input v-model="meta.choiceD" type="text"> </md-input>
                <span class="md-helper-text">请输入选项D</span>
            </md-field>
            <md-field v-if="trigger === 'ExamTrigger'">
                <label>标准答案</label>
                <md-input v-model="meta.answer" type="text"> </md-input>
                <span class="md-helper-text">请输入标准答案</span>
            </md-field>
        </v-app>
    </div>
</template>
<script>
import Tree from "vue-giant-tree";
let ztreeObj = {};
export default {
    name: "Trigger",
    inject: ["taskInfo"],
    computed: {
        treeData() {
            const dictPropertyStr = {
                device: 'treeData',
                scene: 'sceneTreeData'
            };
            return this.taskInfo[dictPropertyStr[this.meta.type]]
        }
    },
    data() {
        return {
            headers: [
                { text: '附加信息', align: 'center', value: 'appendInfo' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            setting: {
                check: {
                    //树是否带复选框或者单选框
                    enable: false,
                },
                data: {
                    simpleData: {
                        //是否使用简单数据模式
                        enable: true,
                        //树节点id，一般是后台数据库主键
                        idKey: "id",
                        //父级id
                        pIdKey: "pid",
                        rootPId: "0",
                    },
                },
                //ztree回调函数
                callback: {
                    //树选择事件
                    onClick: this.treeNodeClick,
                },
            },
            meta: {},
            type: 'device',
            trigger: "",
            showAttachDialog: false,
            appendForm: {},
        };
    },
    watch: {
        meta: {
            deep: true,
            handler: function (val) {
                // this.type = this.meta.type;
                delete this.meta.trigger
                this.$emit("updateTrigger", {
                    type: this.meta.type,
                    trigger: this.trigger,
                    ...this.meta,
                });
            },
        },
        trigger(val) {
            this.$emit("updateTrigger", {
                type: this.meta.type,
                trigger: val,
                deviceId: this.meta.deviceId,
                deviceName: this.meta.deviceName,
            });
        },
    },
    methods: {
        handleCreated(obj) {
            console.log('obj :>> ', obj);
            ztreeObj = obj;
            let uuuid = this.meta.deviceId
            let nodes = obj.getNodes()
            console.log('nodes :>> ', nodes);
            let setModel = (l) => {
                l.forEach((v) => {
                    if (v.id === uuuid) {
                        let tId = v.tId

                        ztreeObj.refresh()

                        let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
                        if (nodeList[0]) {
                            let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
                            if (parentList[0]) {
                                ztreeObj.expandNode(parentList[0], true, false, false)
                            }
                        }
                        this.$nextTick(() => {
                            let dom = document.getElementById(tId + '_a')
                            if (dom) {
                                dom.click()
                            }
                        })
                        // ztreeObj.checkNode(v, true);
                    }
                    if (v.children && v.children.length !== 0) {
                        setModel(v.children)
                    }
                })
            }
            setModel(nodes)
        },
        handleAttachConfirm() {
            const arr = this.meta.appendInfo ?? [];
            arr.push(this.appendForm);
            this.meta.appendInfo = arr;
            this.showAttachDialog = false;
        },
        treeNodeClick(ztreeObj, treeId, treeNode) {
            const treeNodeMap = this.treeData.reduce((pre, next) => {
                pre[next.id] = next;
                return pre;
            }, {});

            const getAliasName = (treeNodeId, treeNodeMap, nodeNameArr = []) => {
                const node = treeNodeMap[treeNodeId];
                nodeNameArr.push(node ? node.name : "");
                if (node.level === 1) {
                    return nodeNameArr.reverse().join("/");
                }
                if (!treeNodeId || !treeNodeMap) {
                    return "";
                }
                return getAliasName(node.pid, treeNodeMap, nodeNameArr);
            };

            this.meta.deviceId = treeNode.id;
            this.meta.deviceName = getAliasName(treeNode.id, treeNodeMap);

            this.$emit("updateTrigger", {
                type: this.meta.type,
                trigger: this.trigger,
                ...this.meta,
            });
        },
        showAttachForm() {
            this.appendForm = {};
            this.showAttachDialog = true;
        },
        handleDelete(index) {
            this.meta.appendInfo.splice(index, 1);
            this.$forceUpdate()
        },
        getData() {
            const data = this.meta;
            return {
                trigger,
                ...data,
            };
        },
        init(form) {
            this.meta = form;
            this.trigger = form.trigger ?? "";
            let treeData = this.taskInfo.treeData;
            if (form.deviceId) {
                const findIndex = treeData.findIndex(
                    (item) => item.id === form.deviceId
                );
                if (findIndex > -1) {
                    treeData[findIndex].checked = true;
                }
            }
            this.treeData = treeData;
        },
    },
    components: {
        Tree,
    },
};
</script>
